(function(){
'use strict';
var cfg=window.MI||{},R=cfg.routes||{};
var RS=R.search||'/search',RP=R.predictive||'/search/suggest',RC=R.cart||'/cart',RA=R.add||'/cart/add',RCH=R.change||'/cart/change';
function qs(s,c){return (c||document).querySelector(s);}
function qa(s,c){return [].slice.call((c||document).querySelectorAll(s));}
function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}

/* ================= menu ================= */
var scrim=qs('[data-scrim]'),head=qs('.head');
var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;
var openT=null,closeT=null;
function closeMega(){
  qa('.mega').forEach(function(m){m.classList.remove('on');});
  qa('[data-mega]').forEach(function(b){b.setAttribute('aria-expanded','false');});
  if(scrim)scrim.classList.remove('on');
}
function openMega(b){
  var p=document.getElementById(b.dataset.mega);if(!p||p.classList.contains('on'))return;
  closeMega();p.classList.add('on');b.setAttribute('aria-expanded','true');
  if(scrim)scrim.classList.add('on');
}
function clearT(){clearTimeout(openT);clearTimeout(closeT);}
if(canHover&&head){
  qa('[data-mega]').forEach(function(b){
    b.addEventListener('mouseenter',function(){clearT();openT=setTimeout(function(){openMega(b);},110);});
    b.addEventListener('focus',function(){clearT();openMega(b);});
  });
  head.addEventListener('mouseenter',clearT);
  head.addEventListener('mouseleave',function(){clearT();closeT=setTimeout(closeMega,220);});
  qa('.mega').forEach(function(m){
    m.addEventListener('mouseenter',clearT);
    m.addEventListener('mouseleave',function(){closeT=setTimeout(closeMega,220);});
  });
  var nv=qs('.nav');if(nv)nv.addEventListener('scroll',function(){clearT();closeMega();},{passive:true});
}
window.addEventListener('resize',function(){clearT();closeMega();},{passive:true});

/* ================= recherche ================= */
var sp=qs('[data-srch]'),qi=qs('[data-q]'),
    sDef=qs('[data-srch-default]'),sLive=qs('[data-srch-live]'),
    sState=qs('[data-srch-state]'),sProd=qs('[data-srch-prod]'),
    sOther=qs('[data-srch-other]'),sAll=qs('[data-srch-all]'),sX=qs('[data-q-clear]');
var ctrl=null,deb=null;
function openSrch(){if(!sp)return;closeMega();closeCart();sp.classList.add('on');if(qi)setTimeout(function(){qi.focus();},60);}
function closeSrch(){if(sp)sp.classList.remove('on');}
function showDefault(){if(sDef)sDef.hidden=false;if(sLive)sLive.hidden=true;if(qi)qi.setAttribute('aria-expanded','false');}
function thumb(u,px){return u?u.replace(/(\.[a-z]+)(\?|$)/i,'_'+px+'x$1$2'):'';}

function render(q,data){
  var r=(data&&data.resources&&data.resources.results)||{};
  var prods=r.products||[],cols=r.collections||[],arts=r.articles||[],pages=r.pages||[];
  if(sDef)sDef.hidden=true;
  if(sLive)sLive.hidden=false;
  if(qi)qi.setAttribute('aria-expanded','true');
  if(!prods.length&&!cols.length&&!arts.length&&!pages.length){
    if(sState)sState.innerHTML='<p class="srch-none">Aucun r\u00e9sultat pour <strong>'+esc(q)+'</strong>. Essayez un mod\u00e8le, par exemple Redmi Note 17.</p>';
    if(sProd)sProd.innerHTML='';if(sOther)sOther.innerHTML='';if(sAll)sAll.hidden=true;
    return;
  }
  if(sState)sState.innerHTML='';
  if(sProd){
    sProd.innerHTML=prods.map(function(p){
      var img=p.featured_image&&p.featured_image.url?'<img src="'+thumb(p.featured_image.url,120)+'" alt="" width="120" height="120" loading="lazy">':'';
      var pz=p.available?((p.price_min!==p.price_max?'d\u00e8s ':'')+(p.price||'')):'Bient\u00f4t';
      var qab='';
      if(p.available){
        var vs=p.variants||[];
        if(vs.length===1&&vs[0]&&vs[0].id)qab='<button type="button" class="qa" data-quick="'+vs[0].id+'" aria-label="Ajouter au panier">+</button>';
        else qab='<button type="button" class="qa" data-quick-go="'+p.url+'" aria-label="Choisir une option">+</button>';
      }
      return '<a class="srch-it" href="'+p.url+'"><span class="im">'+img+'</span><span class="tx"><span class="nm">'+esc(p.title)+'</span><span class="pz">'+esc(pz)+'</span></span>'+qab+'</a>';
    }).join('');
  }
  if(sOther){
    var rest=[].concat(
      cols.map(function(c){return {u:c.url,t:c.title,k:'Rayon'};}),
      arts.map(function(a){return {u:a.url,t:a.title,k:'Guide'};}),
      pages.map(function(a){return {u:a.url,t:a.title,k:'Page'};})
    );
    sOther.innerHTML=rest.length?('<h3>Autres r\u00e9sultats</h3>'+rest.map(function(x){
      return '<a class="srch-lk" href="'+x.u+'"><em>'+x.k+'</em>'+esc(x.t)+'</a>';}).join('')):'';
  }
  if(sAll){sAll.hidden=false;sAll.href=RS+'?q='+encodeURIComponent(q);sAll.textContent='Voir tous les r\u00e9sultats pour \u00ab '+q+' \u00bb \u203a';}
}
function lookup(q){
  if(ctrl)ctrl.abort();
  ctrl=('AbortController' in window)?new AbortController():null;
  if(sState)sState.innerHTML='<p class="srch-wait">Recherche\u2026</p>';
  if(sDef)sDef.hidden=true;if(sLive)sLive.hidden=false;
  fetch(RP+'.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last',
    {signal:ctrl?ctrl.signal:undefined,headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(d){render(q,d);})
    .catch(function(e){if(e.name==='AbortError')return;
      if(sState)sState.innerHTML='<p class="srch-none">La recherche instantan\u00e9e est indisponible. Appuyez sur Entr\u00e9e pour la recherche compl\u00e8te.</p>';});
}
if(qi){
  qi.addEventListener('input',function(){
    var q=qi.value.trim();
    if(sX)sX.hidden=!q;
    clearTimeout(deb);
    if(q.length<2){showDefault();return;}
    deb=setTimeout(function(){lookup(q);},220);
  });
  qi.addEventListener('keydown',function(e){if(e.key==='Escape'){if(qi.value){qi.value='';showDefault();if(sX)sX.hidden=true;}else closeSrch();}});
}
if(sX)sX.addEventListener('click',function(){qi.value='';qi.focus();sX.hidden=true;showDefault();});

/* ================= tiroir panier ================= */
var cd=qs('[data-cartd]'),cBody=qs('[data-cart-body]'),cFoot=qs('[data-cart-foot]'),
    cTot=qs('[data-cart-total]'),cN=qs('[data-cart-n]');
function closeCart(){if(cd){cd.classList.remove('on');document.body.style.overflow='';}}
function openCart(){if(!cd)return;closeMega();closeSrch();cd.classList.add('on');document.body.style.overflow='hidden';loadCart();}
function setCount(n){
  qa('[data-cc]').forEach(function(el){el.textContent=n;el.hidden=!(n>0);});
  if(cN)cN.textContent=n;
}
function money(c){try{return new Intl.NumberFormat('fr-FR').format(Math.round(c/100))+' FCFA';}catch(e){return (c/100)+' FCFA';}}

function drawCart(c){
  setCount(c.item_count);
  if(!c.items||!c.items.length){
    if(cBody)cBody.innerHTML='<div class="cd-empty">'+
      '<span class="ic"><svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.6"/><circle cx="18" cy="20" r="1.6"/><path d="M2 3h3l2.6 12.2a1.5 1.5 0 0 0 1.5 1.2h8.2a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg></span>'+
      '<b>Votre panier est vide</b>'+
      '<p>Ajoutez un produit pour le retrouver ici.</p>'+
      '<a href="/collections">Voir la boutique</a></div>';
    if(cFoot)cFoot.hidden=true;
    return;
  }
  if(cBody){
    cBody.innerHTML=c.items.map(function(it,i){
      var img=it.image?'<img src="'+thumb(it.image,200)+'" alt="" width="100" height="100" loading="lazy">':'';
      var vt=(it.variant_title&&it.variant_title.indexOf('Default')<0)?'<span class="vr">'+esc(it.variant_title)+'</span>':'';
      return '<div class="cd-it" data-line="'+(i+1)+'">'+
        '<a class="im" href="'+it.url+'">'+img+'</a>'+
        '<div>'+
          '<a class="nm" href="'+it.url+'">'+esc(it.product_title)+'</a>'+vt+
          '<div class="bot">'+
            '<span class="cd-qy">'+
              '<button type="button" data-q-dn aria-label="Diminuer">\u2212</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button type="button" data-q-up aria-label="Augmenter">+</button>'+
            '</span>'+
            '<span class="pz">'+money(it.final_line_price)+'</span>'+
          '</div>'+
          '<button type="button" class="rm" data-q-rm>Retirer</button>'+
        '</div>'+
      '</div>';
    }).join('');
  }
  if(cFoot)cFoot.hidden=false;
  if(cTot)cTot.textContent=money(c.total_price);
}
function loadCart(){
  if(cBody)cBody.innerHTML='<p class="cd-load">Chargement\u2026</p>';
  fetch(RC+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(drawCart)
    .catch(function(){if(cBody)cBody.innerHTML='<p class="cd-load">Panier indisponible. <a href="'+RC+'">Ouvrir la page panier</a></p>';});
}
function change(line,qty){
  if(cd)cd.classList.add('busy');
  fetch(RCH+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
    .then(function(r){return r.json();}).then(drawCart).catch(function(){loadCart();})
    .finally(function(){if(cd)cd.classList.remove('busy');});
}
function toast(msg){
  var t=document.createElement('div');t.className='toast';t.setAttribute('role','status');
  t.textContent=msg;document.body.appendChild(t);
  requestAnimationFrame(function(){t.classList.add('on');});
  setTimeout(function(){t.classList.remove('on');setTimeout(function(){t.remove();},300);},3200);
}
function addToCart(id,qty){
  return fetch(RA+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Indisponible');return j;});});
}

/* ---- clics globaux ---- */
document.addEventListener('click',function(e){
  var q=e.target.closest('[data-quick]');
  if(q){
    e.preventDefault();e.stopPropagation();
    var old=q.innerHTML;q.disabled=true;q.innerHTML='<span class="sp"></span>';
    addToCart(q.dataset.quick,1)
      .then(function(){q.classList.add('ok');q.innerHTML='\u2713';setTimeout(function(){q.classList.remove('ok');q.innerHTML=old;q.disabled=false;},900);openCart();})
      .catch(function(err){q.innerHTML=old;q.disabled=false;toast(err.message||"Impossible d'ajouter ce produit");});
    return;
  }
  var g=e.target.closest('[data-quick-go]');
  if(g){e.preventDefault();e.stopPropagation();window.location.href=g.dataset.quickGo;return;}

  var mb=e.target.closest('[data-mega]');
  if(mb){
    var mp=document.getElementById(mb.dataset.mega);
    var href=mb.getAttribute('href');
    if(!href){
      e.preventDefault();clearT();
      if(mp&&mp.classList.contains('on'))closeMega();else openMega(mb);
      return;
    }
    if(canHover){clearT();return;}
    if(mp&&!mp.classList.contains('on')){e.preventDefault();clearT();openMega(mb);return;}
    return;
  }
  if(!e.target.closest('.mega'))closeMega();

  if(e.target.closest('[data-cart-open]')){e.preventDefault();openCart();return;}
  if(e.target.closest('[data-cart-close]')){closeCart();return;}
  if(e.target.closest('[data-srch-open]')){e.preventDefault();openSrch();return;}
  if(e.target.closest('[data-srch-close]')){closeSrch();return;}
  if(e.target.closest('[data-drawer-open]')){var d=qs('[data-drawer]');if(d){d.classList.add('on');document.body.style.overflow='hidden';}return;}
  if(e.target.closest('[data-drawer-close]')){var d2=qs('[data-drawer]');if(d2){d2.classList.remove('on');document.body.style.overflow='';}return;}

  var row=e.target.closest('.cd-it');
  if(row){
    var ln=parseInt(row.dataset.line,10),cur=parseInt(row.querySelector('.cd-qy span').textContent,10)||1;
    if(e.target.closest('[data-q-up]'))change(ln,cur+1);
    else if(e.target.closest('[data-q-dn]'))change(ln,Math.max(0,cur-1));
    else if(e.target.closest('[data-q-rm]'))change(ln,0);
    return;
  }

  var a=e.target.closest('[data-acc]');
  if(a){
    var p=a.nextElementSibling;if(!p)return;
    var o=p.hasAttribute('hidden');
    if(o)p.removeAttribute('hidden');else p.setAttribute('hidden','');
    a.setAttribute('aria-expanded',o?'true':'false');
    var ic=a.querySelector('i');if(ic)ic.textContent=o?'\u2013':'+';
    return;
  }
  var t=e.target.closest('[data-tab]');
  if(t){
    var root=t.closest('[data-tabs]');if(!root)return;
    qa('[data-tab]',root).forEach(function(o){o.setAttribute('aria-selected',o===t?'true':'false');});
    qa('[data-panel]',root).forEach(function(p2){if(p2.dataset.panel===t.dataset.tab)p2.removeAttribute('hidden');else p2.setAttribute('hidden','');});
  }
});

document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  clearT();closeMega();closeCart();
  var d=qs('[data-drawer]');if(d&&d.classList.contains('on')){d.classList.remove('on');document.body.style.overflow='';}
  if(sp&&sp.classList.contains('on')&&(!qi||!qi.value))closeSrch();
});

/* ---- formulaire produit ---- */
document.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches('form[data-add]'))return;
  e.preventDefault();
  var idEl=f.querySelector('[name=id]');if(!idEl){f.submit();return;}
  var btn=f.querySelector('[type=submit]'),lab=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='Ajout\u2026';}
  var qe=f.querySelector('[name=quantity]');
  addToCart(idEl.value,parseInt(qe?qe.value:1,10)||1)
    .then(function(){openCart();})
    .catch(function(err){toast(err.message||"Impossible d'ajouter ce produit");})
    .finally(function(){if(btn){btn.disabled=false;btn.textContent=lab;}});
});

/* ================= variantes ================= */
document.addEventListener('change',function(e){
  var w=e.target.closest('[data-vars]');if(!w)return;
  var src=qs('[data-vjson]',w);if(!src)return;
  var data;try{data=JSON.parse(src.textContent);}catch(err){return;}
  var chosen=qa('[data-opt]',w).map(function(g){var c=qs('input:checked',g);return c?c.value:null;});
  var v=data.find(function(x){return x.o.every(function(o,i){return o===chosen[i];});});
  var id=qs('[name=id]',w),pr=qs('[data-vprice]',w),bt=qs('[type=submit]',w),st=qs('[data-vstock]',w),im=qs('[data-vimg]',w);
  if(!v){if(bt){bt.disabled=true;bt.textContent='Indisponible';}return;}
  if(id)id.value=v.id;
  if(pr)pr.innerHTML=v.p+(v.c?' <s>'+v.c+'</s>':'');
  if(bt){bt.disabled=!v.a;bt.textContent=v.a?'Ajouter au panier':'Rupture de stock';}
  if(st)st.textContent=(v.a&&v.q>0&&v.q<=10)?('Plus que '+v.q+' en stock'):'';
  if(v.i&&im)im.src=v.i;
  if(history.replaceState)history.replaceState({},'',location.pathname+'?variant='+v.id);
});

/* ================= prechargement ================= */
if(cfg.prefetch&&!matchMedia('(prefers-reduced-data: reduce)').matches){
  var seen={},tm=null;
  var warm=function(u){
    if(!u||seen[u])return;
    try{var x=new URL(u,location.href);
      if(x.origin!==location.origin)return;
      if(/\/(cart|account|checkout)/.test(x.pathname))return;
      seen[u]=1;var l=document.createElement('link');l.rel='prefetch';l.href=x.href;l.as='document';document.head.appendChild(l);
    }catch(e){}
  };
  document.addEventListener('mouseover',function(e){var a2=e.target.closest('a[href]');if(!a2)return;clearTimeout(tm);tm=setTimeout(function(){warm(a2.href);},70);},{passive:true});
  document.addEventListener('touchstart',function(e){var a3=e.target.closest('a[href]');if(a3)warm(a3.href);},{passive:true});
}
})();
